import axios from 'axios';
import { getDeviceId } from '../utils/device-info.util';
import { getLocalValue } from '../utils/local-cache.util';
import { LS_ADMIN_USER_AUTH_TOKEN } from '../config/const.config';

const prepareRequestOptions = (url, method, data = null) => {
  const baseAPIUrl = process.env.REACT_APP_CMS_API_ENDPOINT;
  const uuid = getDeviceId();
  const adminAuth = getLocalValue(LS_ADMIN_USER_AUTH_TOKEN);

  const options = {
    url: `${baseAPIUrl}${url}`,
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Req-Device': uuid,
      'X-Admin-Auth-Token': adminAuth,
    },
    data: JSON.stringify(data || {}),
  };

  return options;
};

export const getCounters = async () => {
  const options = prepareRequestOptions('/reports/counters', 'GET');

  const response = await axios(options);
  return response.data;
};

export const getVideosReportData = async (payload) => {
  const options = prepareRequestOptions(
    '/reports/export/videos',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const getAdsReportData = async (payload) => {
  const options = prepareRequestOptions('/reports/export/ads', 'POST', payload);

  const response = await axios(options);
  return response.data;
};

export const getAppsExportData = async (payload) => {
  const options = prepareRequestOptions(
    '/reports/export/apps',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const getVideos = async () => {
  const options = prepareRequestOptions('/reports/list/videos', 'GET');

  const response = await axios(options);
  return response.data;
};

export const getSummary = async (sDate, eDate) => {
  const options = prepareRequestOptions(
    `/reports/summary?startDate=${sDate}&endDate=${eDate}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const getUserLocationsData = async (params = 'platform') => {
  const options = prepareRequestOptions(
    `/reports/user-locations?groupBy=${encodeURIComponent(params)}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const getEngagementReportsData = async (startDate, endDate) => {
  const options = prepareRequestOptions(
    `/reports/engagement?startDate=${startDate}&endDate=${endDate}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};
